import { usePLMapboxStoreV2 as s } from "./index.es6.js";
const r = () => {
  const {
    setLegendItems: e,
    addLegendItem: t,
    removeLegendItem: o,
    updateLegendItem: n
  } = s((d) => d.actions);
  return {
    setLegendItems: e,
    addLegendItem: t,
    removeLegendItem: o,
    updateLegendItem: n
  };
};
export {
  r as usePLMapboxLegendActions
};
//# sourceMappingURL=index.es182.js.map
